const menus = [
    {
        id: 1,
        tomenu: "#about",
        namemenu: "Courses"
    },
    /*{
        id: 2,
        tomenu: "#banner",
        namemenu: "Curse II"
    },*/
    {
        id: 3,
        tomenu: "#testimonial",
        namemenu: "testimonials"
    },
    {
        id: 4,
        tomenu: "#contact",
        namemenu: "Contact"
    }
    /*{
        id: 5,
        tomenu: "#contact",
        namemenu: "Contact"
    },*/
];



export default menus ;